import script from "./MediumSizedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MediumSizedModal.vue?vue&type=script&setup=true&lang=js"

import "./MediumSizedModal.vue?vue&type=style&index=0&id=442883da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-442883da"]])

export default __exports__